import styled from 'styled-components';

export const Wrapper = styled.div<{ $isSelected: boolean; $isDisabled: boolean }>`
  display: flex;
  width: 100%;
  padding: 12px 16px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  border-radius: 8px;
  border: 1px solid
    ${({ theme, $isSelected }) => ($isSelected ? theme.colors.green6 : theme.colors.black4)};
  background: ${({ theme, $isSelected }) =>
    $isSelected ? theme.colors.green1 : theme.colors.white};
  cursor: pointer;
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};

  &:hover {
    background: ${({ theme }) => theme.colors.green1};
    border: 1px solid ${({ theme }) => theme.colors.green6};
  }
`;

export const CourseInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const CourseNameWrapper = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;

export const EmojiWrapper = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  padding: 0px 6px;
  align-items: center;
  justify-content: center;
  font-size: 30px;
`;

export const PracticeCountWrapper = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
